const FAQS = [
  {
    question: "How much does storage cost?",
    answer: "Storage is included, free of charge.",
  },
  {
    question: "I don't want serverless. Can I use Beam while keeping the server running 24/7?",
    answer:
      "Yes. By default, apps will spin down automatically after each request, but you can control how long your apps are active. Many customers with latency-sensitive workloads choose to keep their servers running 24/7 on Beam.",
  },
  {
    question: "Am I billed for cold start?",
    answer:
      "No. We only charge for the time to load your application code. We don’t charge for the time to spin up a server or load your container image.",
  },
  {
    question: "I have an existing Docker image. Can I use it on Beam?",
    answer: "Yes. You can import any base image from a third-party image registry onto Beam.",
  },
  {
    question: "How secure is Beam?",
    answer:
      "Workloads are isolated from one another and run in non-root containers. We also offer a self-hosted product which runs entirely in your own environment, ensuring that no data leaves your VPC.",
  },
];

export default FAQS;
